import styled, { css } from 'styled-components';
import media from '../../../constants/media';

export const InputWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	${media.mobileOnly`
		flex-wrap: wrap;
	`};
`;

export const TextWrapper = styled.div`

`;

export const ButtonWrapper = styled.div`
	margin-left: 1.5rem;

	${media.mobileOnly`
		display: flex;
		justify-content: center;
		width: 100%;
		margin-left: 0;
		margin-top: 1rem;
	`};
`;

export const Wrapper = styled.div``;

export const TableWrapper = styled.div`
	margin-top: 2rem;
`;

export const InputAndDropdownWrapper = styled.div`
	width: 100%;
	position: relative;
`;

export const DropdownWrapper = styled.div`
	position: absolute;
	width: 100%;
`;

export const List = styled.div``;

export const Item = styled.div`
	padding: 0.5rem 2.5rem;
	background-color: ${({ theme }) => theme.colors.grayLighter};

	${({ highlighted }) =>
		highlighted &&
		css`
			background-color: ${({ theme }) => theme.colors.grayLight};
		`};
`;
